import React, { useEffect, useState } from "react";
import {
  Search,
  RefreshCw,
  LogOut,
  ShieldCheck,
  MessageSquareMore
} from "lucide-react";

import "./Navbar.css";

export default function Navbar({
  onLogout,
  searchTerm = "",
  setSearchTerm = () => {},
  onRefresh = () => {}
}) {

  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {

    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);

  }, []);

  const formattedDate = currentTime.toLocaleDateString(
    "en-IN",
    {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric"
    }
  );

  const formattedTime = currentTime.toLocaleTimeString(
    "en-IN",
    {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }
  );

  return (

    <header className="navbar">

      <div className="navbar-brand">

        <div className="logo-box">

          <MessageSquareMore size={24}/>

        </div>

        <div>

          <h1>

            Tally Prime Messenger

          </h1>

          <span>

            Subscription & License Management Portal

          </span>

        </div>

      </div>

      <div className="navbar-search">

        <Search
          size={18}
          className="search-svg"
        />

        <input

          type="text"

          placeholder="Search client, serial number, WhatsApp..."

          value={searchTerm}

          onChange={(e)=>setSearchTerm(e.target.value)}

        />

      </div>

      <div className="navbar-right">

        <div className="datetime-card">

          <span>

            {formattedDate}

          </span>

          <strong>

            {formattedTime}

          </strong>

        </div>

        <button

          className="icon-btn"

          onClick={onRefresh}

          title="Refresh"

        >

          <RefreshCw size={18}/>

        </button>

        <div className="admin-card">

          <div className="avatar">

            <ShieldCheck size={20}/>

          </div>

          <div>

            <div className="admin-name">

              Administrator

            </div>

            <div className="admin-status">

              Online

            </div>

          </div>

        </div>

        <button

          className="logout-btn"

          onClick={onLogout}

        >

          <LogOut size={17}/>

          Logout

        </button>

      </div>

    </header>

  );

}